/**
 * Pre-Lander Component
 * Shows/hides pre-lander based on URL parameters
 */

class PreLander {
  constructor(sectionId, urlParams) {
    this.sectionId = sectionId;
    this.urlParams = urlParams;
    this.init();
  }

  init() {
    const sectionWrapper = document.getElementById('shopify-section-' + this.sectionId);
    if (!sectionWrapper) return;

    const preLander = sectionWrapper.querySelector('.pre-lander');
    if (!preLander) return;

    if (!this.urlParams) return;

    if (this.shouldShowPreLander()) {
      this.showPreLander(preLander);
    }
  }

  shouldShowPreLander() {
    const paramsArray = this.urlParams.split(',').map(param => param.trim());
    const searchParams = new URLSearchParams(window.location.search);

    for (const param of paramsArray) {
      // Check if param contains = (key=value format like "utm=456")
      if (param.includes('=')) {
        const [key, value] = param.split('=').map(p => p.trim());
        const urlValue = searchParams.get(key);
        
        if (urlValue === value) {
          return true;
        }
      } else {
        // For params without = (like "test123"), check:
        // 1. If it exists as a key (e.g., ?test123 or ?test123=)
        // 2. If it appears as a value (e.g., ?something=test123)
        const hasKey = searchParams.has(param);
        const hasValue = Array.from(searchParams.values()).includes(param);
        
        if (hasKey || hasValue) {
          return true;
        }
      }
    }

    return false;
  }

  showPreLander(preLander) {
    preLander.classList.remove('pre-lander--hide');

    // Hide site header offset spacer
    const spacer = document.querySelector('.site-header-offset');
    if (spacer) {
      spacer.classList.add('pre-lander--spacer-hidden');
    }
  }
}

// Initialize pre-lander instances
window.PreLander = PreLander;

